import { FC } from 'react'
import { Redirect, Route, RouteComponentProps } from 'react-router'

type SimpleRouteWithLayoutProps = {
  layout: FC
  component: FC<RouteComponentProps>
  path: string
  exact?: boolean
}

const SimpleRoute: FC<SimpleRouteWithLayoutProps> = ({
  component: Component,
  layout: Layout,
  children,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(matchProps: any) => (
        <Layout>
          <Component {...matchProps}>{children}</Component>
        </Layout>
      )}
    />
  )
}

export default SimpleRoute
